import styled, { css } from "styled-components";
import { useDesignTokens, parseSizeToken } from "@boi/react-design-tokens";

export const Container = styled.label`
  ${() => {
    const { tokens } = useDesignTokens();
    const { inputLabelRight } = tokens;

    return css`
      display: grid;
      grid-template-columns: auto;
      grid-auto-flow: column;
      grid-auto-columns: 1fr;
      gap: ${inputLabelRight.gap};
      user-select: none;
      cursor: pointer;
      font-size: 0;

      &:has(:disabled) {
        cursor: not-allowed;
      }

      &:has(:focus-visible) {
        outline-width: ${inputLabelRight.focusRing.width};
        outline-style: ${inputLabelRight.focusRing.style};
        outline-color: ${inputLabelRight.focusRing.color};
        outline-offset: ${inputLabelRight.focusRing.offset};
        border-radius: ${inputLabelRight.focusRing.radius};
      }
    `;
  }}
`;

type InputWrapperProps = {
  $label?: string;
};

export const InputWrapper = styled.div<InputWrapperProps>`
  ${({ $label }) => {
    const { tokens } = useDesignTokens();
    const { inputLabelRight } = tokens;

    return [
      css`
        display: grid;
        place-items: center;
      `,
      $label &&
        css`
          height: ${parseSizeToken(inputLabelRight.inputWrapper.height)};
        `,
    ];
  }}
`;

export const LabelWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { inputLabelRight } = tokens;

    return css`
      color: ${inputLabelRight.label.color.base};

      label:has(:disabled) && {
        color: ${inputLabelRight.label.color.disabled};
      }
    `;
  }}
`;
